/** @jsxImportSource @emotion/react */

import React from 'react';

interface IProps extends React.SVGProps<SVGSVGElement> {
  width?: number | string;
  height?: number | string;
}

function ScreenFullFilledIcon(props: IProps) {
  const { ...rest } = props;

  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...rest}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.9395 6H14.772V4.5H19.5V9.228H18V7.0605L14.031 11.031L12.969 9.969L16.9395 6ZM6 16.9395L9.969 12.969L11.031 14.031L7.0605 18H9.228V19.5H4.5V14.772H6V16.9395Z"
        fill="currentColor"
      />
    </svg>
  );
}

export default ScreenFullFilledIcon;
